import { ActionType, createAction } from 'typesafe-actions';

export const patientReadyAction = createAction('PATIENT_READY', (consultID: string) => consultID)();

export const togglePlayAudio = createAction('TOGGLE_PLAY_AUDIO', () => {})();

export type GetWaitingRoomActionTypes = ActionType<
  typeof togglePlayAudio | typeof patientReadyAction
>;
